import { OnChanges } from '@angular/core';
var StackedChartComponent = /** @class */ (function () {
    function StackedChartComponent() {
        this.results = [];
        this.isLoading = true;
        this.schemePieColor = {
            domain: ['#12b886', '#ff3365']
        };
        this.labelColorDomain = [];
        this.showXAxis = true;
        this.showYAxis = true;
        this.showLegend = false;
    }
    StackedChartComponent.prototype.ngOnChanges = function () {
        if (Array.isArray(this.results)) {
            var diff = Math.ceil(this.results.length / this.schemePieColor.domain.length) - 1;
            this.labelColorDomain = this.schemePieColor.domain;
            for (var index = 0; index < diff; index++) {
                this.labelColorDomain = this.labelColorDomain.concat(this.schemePieColor.domain);
            }
        }
    };
    return StackedChartComponent;
}());
export { StackedChartComponent };
